
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/layout",
      function () {
        return require("private-next-pages/layout.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/layout"])
      });
    }
  